import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { TextMaskModule } from 'angular2-text-mask';
import { ToastrService, ToastNoAnimation } from 'ngx-toastr';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { PhoneNumberPipe } from './pipes/phone-number.pipe';
import { DynamicDecimalPipe } from './pipes/dynamicDecimalPipe';
import { HideIfDecimalDirective } from './directive/hideIfDecimal';
// import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { GenerateStripeTokenComponent } from '../generate-stripe-token/generate-stripe-token.component';
// import { NgxSelectModule } from 'ngx-select-ex/ngx';
// import { NgxPlaidLinkModule } from 'ngx-plaid-link';
import { GpayComponent } from './wallet/gpay/gpay.component';
import { ApplepayComponent } from './wallet/applepay/applepay.component';
import { TooltipDirective } from './directive/tooltip.directive';
import { ZipCodeComponent } from './zip-code/zip-code.component';
import { MaterialModule } from './material.module';
import { GoogleApiComponent } from './google-api/google-api.component';
import { GooglePayButtonModule } from '@google-pay/button-angular';
// import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { IConfig, NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { TrimDirective } from './directive/trim.directive';
import { DobDirective } from './directive/dob.directive';
import { ConsentFormComponent } from '../pages/consent-form/consent-form.component';
import { ToasterService } from '../services/toaster.service';
import { NgxGpAutocompleteModule } from '@angular-magic/ngx-gp-autocomplete';
import { Loader } from '@googlemaps/js-api-loader';
import { SignaturePadComponent } from './signature-pad/signature-pad.component';

import { GenerateSignatureComponent } from './generate-signature/generate-signature.component';
import { environment } from 'src/environments/environment';
import { AlphabetsOnlyDirective } from './directive/alphabets-only.directive';
import { RecaptchaModule } from 'ng-recaptcha';
import { CaptchaComponent } from './captcha/captcha.component';
let gMapKey: string;
const maskConfig: Partial<IConfig> = {
  validation: false,
};
@NgModule({
  imports: [
    CommonModule,
    DynamicDecimalPipe,
    PhoneNumberPipe,
    FormsModule,
    SafeHtmlPipe,
    ReactiveFormsModule,
    // TextMaskModule,
    // NgxSelectModule,
    TypeaheadModule.forRoot(),
    // TooltipModule.forRoot(),
    // NgxPlaidLinkModule,
    GooglePayButtonModule,
    NgxGpAutocompleteModule,
    // MaterialModule,
    // GooglePlaceModule,
    // NgxMaskModule.forRoot(maskConfig)
    NgxMaskDirective,
    NgxMaskPipe,
    AlphabetsOnlyDirective,
    RecaptchaModule,
  ],
  providers: [TooltipDirective, ToasterService, ToastrService, provideNgxMask(), {
    provide: Loader,
    useValue: new Loader({
      apiKey: environment.googleKey,
      libraries: ['places']
    })
  }, AlphabetsOnlyDirective],
  // tslint:disable-next-line:max-line-length
  declarations: [
    HideIfDecimalDirective,
    GpayComponent,
    ApplepayComponent,
    ZipCodeComponent,
    TooltipDirective,
    GoogleApiComponent,
    TrimDirective,
    DobDirective,
    // ConsentFormComponent,
    SignaturePadComponent,
    GenerateStripeTokenComponent,
    GenerateSignatureComponent,
    CaptchaComponent,
  ],
  // tslint:disable-next-line:max-line-length
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PhoneNumberPipe,
    SafeHtmlPipe,
    DynamicDecimalPipe,
    GenerateStripeTokenComponent,
    GpayComponent,
    ApplepayComponent,
    ZipCodeComponent,
    TooltipDirective,
    MaterialModule,
    GoogleApiComponent,
    // TrimDirective,
    // DobDirective,
    // ConsentFormComponent,
    SignaturePadComponent,
    GenerateSignatureComponent,
    NgxMaskDirective,
    NgxMaskPipe,
    
    HideIfDecimalDirective,
    AlphabetsOnlyDirective,
    CaptchaComponent,
  ],
})

// https://github.com/ocombe/ng2-translate/issues/209
export class SharedModule { }